var $5d74ec2bd0ee432a$exports = {};
$5d74ec2bd0ee432a$exports = {
    "alert": `Teade`,
    "dismiss": `L\xf5peta`
};


export {$5d74ec2bd0ee432a$exports as default};
//# sourceMappingURL=et-EE.mjs.map
